import {faMedal, faQuestion} from '@fortawesome/free-solid-svg-icons';
import React, {useState} from 'react';
import {Image} from 'react-native';
import {globalStateContext} from '../../../App.jsx';
import Circle from '@/components/web/Circle.jsx';
import QuizItemCard from '@/components/web/QuizItemCard.jsx';
import {CommonWebBox, MyView, PhoneView, SimpleText} from '@/styles';
import {styles} from '@/styles/common/styles.js';
import vars from '@/styles/root';
import {useTheme} from 'styled-components';
function BoxRanking(props) {
  const [pic, setPic] = useState();
  React.useEffect(() => {
    setPic(props.pic);
  }, [props.pic]);
  const useGlobalState = () => [React.useContext(globalStateContext)];
  const [state] = useGlobalState();
  const theme = useTheme();
  return (
    <CommonWebBox
      style={{backgroundColor: theme.colors.background.modal}}
      width={state.isInPhone ? 320 : 390}>
      <Circle
        style={{
          position: 'absolute',
          marginRight: state.isInPhone ? -45 : -85,
          marginTop: 20,
        }}
        child={
          pic && (
            <Image
              style={{
                width: state.isInPhone ? '90px' : '140px',
                height: state.isInPhone ? '90px' : '140px',
                borderRadius: '50%',
                objectFit: 'cover',
                objectPosition: 'center',
              }}
              source={pic}
            />
          )
        }
        width={state.isInPhone ? 100 : 150}
        height={state.isInPhone ? 100 : 150}
        borderRadius={'50%'}
        backgroundColor={
          theme.name === 'dark' ? theme.colors.text.base : vars.YELLOW_WHITE
        }
      />
      <PhoneView
        style={{
          ...styles.positionAbsolute,
          top: -25,
          left: 15,
          ...styles.gap15,
        }}>
        <SimpleText
          style={{
            color: theme.colors.warning,
            ...styles.alignSelfCenter,
          }}
          text={props.useFilter ? 'رتبه در پایه تحصیلی' : 'رتبه در آیریسک'}
        />
        <Circle
          diameter={50}
          text={props.rank}
          color={theme.colors.text.warning}
          backgroundColor={theme.colors.warning}
        />
      </PhoneView>
      <MyView
        style={{
          paddingRight: 70,
          ...styles.gap15,
          ...styles.marginTop20,
        }}>
        <PhoneView
          style={{
            ...styles.justifyContentSpaceBetween,
          }}>
          <QuizItemCard
            textFontSize={10}
            valFontSize={16}
            text={'تعداد آزمون شرکت کرده '}
            val={props.valQuiz}
            icon={faQuestion}
            iconFontSize={'normal'}
            color={vars.ORANGE}
          />
          <QuizItemCard
            textFontSize={10}
            valFontSize={16}
            text={'جمع امتیاز'}
            val={props.valScore}
            icon={faMedal}
            iconFontSize={'normal'}
            backgroundColor={vars.ORANGE}
            color={vars.ORANGE}
          />
        </PhoneView>
        <MyView
          style={{
            ...styles.justifyContentCenter,
            ...styles.paddingRight15,
            backgroundColor: theme.colors.alert,
            borderRadius: 5,
            height: 40,
            marginRight: 0,
          }}>
          <SimpleText
            style={{
              color: theme.colors.text.alert,
              ...styles.bold,
              ...styles.fontSize15,
            }}
            text={'نام و نام خانوادگی :' + ' ' + props.name}
          />
        </MyView>
        <MyView
          style={{
            marginTop: -10,
            ...styles.gap5,
          }}>
          <SimpleText
            style={{
              color: theme.colors.text.base,
            }}
            text={'مدرسه : ' + ' ' + props.school}
          />
          <SimpleText
            style={{
              color: theme.colors.text.base,
            }}
            text={'شهر : ' + ' ' + props.city}
          />
          <SimpleText
            style={{
              color: theme.colors.text.base,
            }}
            text={'پایه : ' + ' ' + props.grade}
          />
          {props.field !== undefined && props.field !== '' && (
            <SimpleText
              style={{
                color: theme.colors.text.base,
              }}
              text={'رشته : ' + ' ' + props.field}
            />
          )}
        </MyView>
      </MyView>
    </CommonWebBox>
  );
}
export default BoxRanking;
